var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeclineAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#BF3F3F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9844 6.98047L11.9727 9.99219L14.9805 13L13 14.9805L9.99219 11.9727L6.98438 14.9805L5.00391 13L8.01172 9.99219L5 6.98047L6.98047 5L9.99219 8.01172L13.0039 5L14.9844 6.98047Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclineAction);
export default __webpack_public_path__ + "static/media/decline-action.3496e5ad10417ab97fa855e8bc8523a6.svg";
export { ForwardRef as ReactComponent };